module.exports = __webpack_public_path__ + "img/email-marketing-th.3d180e90.png";